import { z } from 'zod';
import { reminderAudienceSchema } from '#src/approval-reminders/reminders.contract.js';
/** Limite de segurança de chamados em um único envio de teste. */
export const TEST_REMINDER_MAX_TICKETS = 20;
export const testReminderRequestSchema = z.strictObject({
    /** Quem recebe o card, no lugar dos aprovadores ou do solicitante reais. */
    recipientEmail: z.email(),
    /** Qual versão do card montar. */
    audience: reminderAudienceSchema,
    /** Números dos chamados como os usuários os conhecem (`id_chamado`). */
    ticketNumbers: z
        .array(z.string().min(1))
        .min(1)
        .max(TEST_REMINDER_MAX_TICKETS),
});
export const testReminderResponseSchema = z.strictObject({
    deliveryId: z.uuid(),
    activityId: z.string().min(1),
    attempts: z.int().positive(),
    /** Chamados incluídos no card. */
    ticketNumbers: z.array(z.string()),
    /** Números pedidos que não estão em aprovação e ficaram de fora. */
    notFound: z.array(z.string()),
});
//# sourceMappingURL=test-reminder.contract.js.map